import { useState } from "react";
import { DefectComment } from "../..";
import { UserRole } from "imagine-users";
import { Alert, Button, ImageDropzone, Label, TextInput } from "imagine-ui";
import { useTranslation } from "react-i18next";

interface Props {
  comment?: DefectComment;
  defectId: number;
  onSave: (comment: DefectComment, images: File[]) => void;
  errorMessage?: string;
  saving?: boolean;
  className?: string;
}

const getEmptyComment = (defectId: number): DefectComment => {
  return {
    id: 0,
    defectId: defectId,
    text: "",
  };
};

export const CommentEditor = (props: Props) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState<DefectComment>(
    props.comment || getEmptyComment(props.defectId)
  );
  const [images, setImages] = useState<File[]>([]);

  const updateText = (text: string) => {
    setComment({ ...comment, text });
  };

  const save = () => {
    props.onSave(comment, images);
  };

  return (
    <div className={props.className}>
      {props.errorMessage && (
        <Alert color="danger" className="mb-sm">
          {props.errorMessage}
        </Alert>
      )}
      <Label>{t("punchlist:comment")}</Label>
      <TextInput
        value={comment.text}
        onChange={updateText}
        multiline
        height="md"
      />
      <ImageDropzone onChange={setImages} className="mt-sm" limit={8} />
      <Button className="mt-sm" onClick={save} loading={props.saving}>
        {t("imagine:add")}
      </Button>
    </div>
  );
};
